<template>
	<div v-cloak class="component-container component-modal modal-container minified-sidebar">
		<div class="modal-inner modal-positioning">
			<div class="modal-inner-container">
				<div class="modal-header">
					<slot name="header" />
					<button class="modal-close btn btn-icon" title="Close Overlay" @click="close">
						<i class="fas fa-times" />
					</button>
				</div>
				<div class="modal-content">
					<slot name="content" />
				</div>
				<div v-if="hasFooterSlot" class="modal-footer">
					<slot name="footer" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed, useSlots } from 'vue';

	const emit = defineEmits(['close']);

	const slots = useSlots();
	const hasFooterSlot = computed(() => typeof slots.footer !== 'undefined');

	const close = () => {
		emit('close');
	};
</script>

<style lang="scss" scoped>
	@use '../assets/styles/modules/modal';
	@use '../assets/styles/modules/button';
</style>
